module.exports = __webpack_public_path__ + "static/media/Colette Curve Single Headboard - 120 cm_Dark Brown.ce01ac4b.png";